<template>
    <div class="bg-white full-height container">
        <div v-if="documentSettingsPane" class="container full-height">
            <b-row no-gutters class="full-height">
                <b-col class="full-height" cols="9">
                    <main-input-container :lock-text="$route.params.lockText" />
                </b-col>
                <b-col class="full-height" cols="3">
                    <document-settings class="settings"/>
                </b-col>
            </b-row>
        </div>
        <main-input-container v-else :lock-text="$route.params.lockText" class="row no-gutters" />
        <welcome ref="welcome-popup" v-on:show-keyboard-shortcuts="$emit('show-keyboard-shortcuts')"/>
        <failed-validation-popup />
    </div>
</template>

<script>
    // @ is an alias to /src
    import DocumentSettings from '@/components/DocumentSettings.vue'
    import MainInputContainer from '@/components/MainInputContainer.vue'
    import Welcome from '@/components/Welcome.vue'
    import serviceMixins from '@/mixins/serviceMixins'
    import FailedValidationPopup from '@/components/FailedValidationPopup.vue'
    import {AppConfig} from '@/appConfig'
    import {loadingPromise} from "@/js/localData"
    import {getDevFrontendSettings} from 'shared/js/devMode'

    export default {
        name: 'TextPrep',
        components: {
            DocumentSettings,
            MainInputContainer,
            Welcome,
            FailedValidationPopup
        },
        mixins: [serviceMixins], // for googleAnalyticsId and gtag()
        computed: {
            documentSettingsPane () {
                return AppConfig.PRE_SUBMISSION_OPTIONS_TO_SHOW.ONLY_GENRE
                        || AppConfig.PRE_SUBMISSION_OPTIONS_TO_SHOW.ALL
                        || getDevFrontendSettings('abbreviation')?.documentSettingsPane
            },
        },
        mounted() {
            this.gtag('config', this.googleAnalyticsId, {'page_title': 'textprep', 'page_path': '/'})
            const mediaQueryBigEnough = window.matchMedia('(min-width: 768px)').matches
            loadingPromise.then(() => {
                if (this.$store.state.firstTimeInitialized && mediaQueryBigEnough) {
                    this.$refs['welcome-popup'].$children[0].show() // the $ref is the COMPONENT, $children[0] is the modal
                    this.$store.commit('CONFIRM_FIRST_TIME_INITIALIZED')
                }
            })
        },
        beforeDestroy() {
            // (will have to be imported if we uncomment this) StateSaver.saveState(this.$store.state)
        }

    }
</script>

<style scoped>
.container {
    background-color: unset !important;
}
</style>
